import { X, Check } from 'lucide-react';
import { useFitnessStore } from '../../../store/fitnessStore';
import { PLANS, redirectToCheckout } from '../../../services/stripe';

export default function UpgradeModal() {
  const modal = useFitnessStore((s) => s.modal);
  const closeModal = useFitnessStore((s) => s.closeModal);
  const profile = useFitnessStore((s) => s.profile);
  if (modal?.type !== 'upgrade') return null;

  return (
    <div
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.9)', zIndex: 100, display: 'flex', alignItems: 'flex-end', backdropFilter: 'blur(8px)' }}
      onClick={closeModal}
      role="presentation"
    >
      <div style={{ background: '#141416', borderRadius: '20px 20px 0 0', width: '100%', padding: 24, maxHeight: '90vh', overflowY: 'auto' }} onClick={(e) => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
          <div>
            <div style={{ fontFamily: 'Bebas Neue', fontSize: 26 }}>UPGRADE YOUR GAME</div>
            <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.4)' }}>Unlock the full FitLife Pro experience</div>
          </div>
          <button type="button" onClick={closeModal} style={{ background: 'rgba(255,255,255,0.08)', border: 'none', borderRadius: 8, padding: 8, cursor: 'pointer', color: '#fff' }}><X size={18} /></button>
        </div>

        <div style={{ background: 'rgba(232,255,71,0.05)', border: '2px solid rgba(232,255,71,0.3)', borderRadius: 16, padding: 16, marginBottom: 12 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 12 }}>
            <div>
              <div style={{ fontSize: 11, fontWeight: 700, color: '#E8FF47', letterSpacing: 1, marginBottom: 2 }}>MOST POPULAR</div>
              <div style={{ fontFamily: 'Bebas Neue', fontSize: 24 }}>PRO</div>
            </div>
            <div style={{ textAlign: 'right' }}>
              <div style={{ fontFamily: 'Bebas Neue', fontSize: 28, color: '#E8FF47' }}>$9.99</div>
              <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.4)' }}>per month</div>
            </div>
          </div>
          {PLANS.pro.features.map((f, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
              <Check size={13} color="#E8FF47" />
              <span style={{ fontSize: 12, color: 'rgba(255,255,255,0.75)' }}>{f}</span>
            </div>
          ))}
          <button
            type="button"
            onClick={() => { redirectToCheckout(PLANS.pro.priceIdMonthly, profile.id); closeModal(); }}
            style={{ width: '100%', marginTop: 14, background: '#E8FF47', color: '#0A0A0B', border: 'none', borderRadius: 10, padding: 12, fontWeight: 700, fontSize: 14, cursor: 'pointer' }}
          >
            Start Pro — $9.99/mo
          </button>
        </div>

        <div style={{ background: 'rgba(180,126,255,0.05)', border: '1px solid rgba(180,126,255,0.2)', borderRadius: 16, padding: 16, marginBottom: 12 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 12 }}>
            <div>
              <div style={{ fontSize: 11, fontWeight: 700, color: '#B47EFF', letterSpacing: 1, marginBottom: 2 }}>BEST FOR ATHLETES</div>
              <div style={{ fontFamily: 'Bebas Neue', fontSize: 24 }}>ELITE</div>
            </div>
            <div style={{ textAlign: 'right' }}>
              <div style={{ fontFamily: 'Bebas Neue', fontSize: 28, color: '#B47EFF' }}>$19.99</div>
              <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.4)' }}>per month</div>
            </div>
          </div>
          {PLANS.elite.features.map((f, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
              <Check size={13} color="#B47EFF" />
              <span style={{ fontSize: 12, color: 'rgba(255,255,255,0.75)' }}>{f}</span>
            </div>
          ))}
          <button
            type="button"
            onClick={() => { redirectToCheckout(PLANS.elite.priceIdMonthly, profile.id); closeModal(); }}
            style={{ width: '100%', marginTop: 14, background: '#B47EFF', color: '#fff', border: 'none', borderRadius: 10, padding: 12, fontWeight: 700, fontSize: 14, cursor: 'pointer' }}
          >
            Start Elite — $19.99/mo
          </button>
        </div>
        <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.25)', textAlign: 'center' }}>Cancel anytime. No hidden fees.</div>
      </div>
    </div>
  );
}
